module.exports = "/_next/static/images/fallback_XL-5b76ffd3ffd07a9d96f5ec0407e537f7.png";